<div class="d-flex justify-content-start gap-3 " style="background-color: transparent;">
    <div style="width: 100%;" >
        <select-drop-down [items]="values" [(ngModel)]="value" [options]="{ filter:{ byKey:'element_Bio' ,with:'containe'} }" name="biologie">
            <ng-template let-item="item">{{item.element_Bio}}</ng-template>
        </select-drop-down>
    </div>
    <div >
        <button class="openDialoge" (click)="openDialoge()">
            <i class="feather-plus-circle"></i>
        </button>
    </div>
</div>

<app-modal [title]="'Ajouter Analyse Biologique'" #dialog>
    <app-biology-form #biologyForm></app-biology-form>
    <button class="btn btn-outline-info mb-3 mt-3" (click)="onAddBiology()">Ajouter Analyse</button>
</app-modal>
